<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="gimCustoms"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-gim-custom") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'gimCustoms'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-gim-custom
      :modelDialog="gimCustomDialog"
      @close="gimCustomDialog = false"
    ></add-edit-gim-custom>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditGimCustom from "./admin/AddEditGimCustom.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "SapgAdmin",
  components: { AddEditGimCustom, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      gimCustomDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      gimCustoms: (state) => state.gimCustoms.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.gimCustoms.editedId
    }),
    pageCount() {
      return Math.ceil(this.gimCustoms.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "gimCustoms");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "gimCustoms");
    },
    openDialog() {
      this.$store.commit("gimCustoms/setEditedId", -1);
      this.$store.commit("gimCustoms/setEditedItem", Object.assign({}, {}));
      this.gimCustomDialog = true;
    },
    editItem(item) {
      this.$store.commit("gimCustoms/setEditedId", item.id);
      this.$store.commit("gimCustoms/setEditedItem", Object.assign({}, item));
      this.gimCustomDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.gim-custom"))) {
        this.$store
          .dispatch("gimCustoms/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.gim-custom-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "gimCustoms");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.gim-custom-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
